export default {
	api: {
		key: 'AIzaSyBQN9RtQt3wGQn62ub_X7yxSCJpGCflbzA',
	},
}
